
namespace Matrix.Indexation {
    export class DimIndexationProfileColumns {
        static columnsKey = 'Indexation.DimIndexationProfile';
    }
}